export enum BorderAlignmentTypes {
    MIDDLE = 'MIDDLE',
    INSIDE = 'INSIDE',
    OUTSIDE = 'OUTSIDE',
}
